module.exports = __webpack_public_path__ + "static/media/business.bb9598b2.png";